/**
 * Iran Region Data
 * Comprehensive data for the Islamic Republic of Iran
 */

import { Region, RegionHistoricalPeriod } from "../../types/regions";

/**
 * Historical periods for Iran
 */
export const IRAN_HISTORICAL_PERIODS: RegionHistoricalPeriod[] = [
  {
    id: "achaemenid",
    name: "Achaemenid Empire",
    startYear: -550,
    endYear: -330,
    description: "The first Persian Empire, founded by Cyrus the Great",
  },
  {
    id: "parthian",
    name: "Parthian Empire",
    startYear: -247,
    endYear: 224,
    description: "The Arsacid dynasty that ruled the Iranian plateau",
  },
  {
    id: "sasanian",
    name: "Sasanian Empire",
    startYear: 224,
    endYear: 651,
    description: "The last pre-Islamic Persian Empire",
  },
  {
    id: "safavid",
    name: "Safavid Dynasty",
    startYear: 1501,
    endYear: 1736,
    description: "Established Shia Islam as the state religion",
  },
  {
    id: "qajar",
    name: "Qajar Dynasty",
    startYear: 1789,
    endYear: 1925,
    description: "The dynasty that preceded the Pahlavi era",
  },
  {
    id: "pahlavi",
    name: "Pahlavi Dynasty",
    startYear: 1925,
    endYear: 1979,
    description: "The last imperial dynasty of Iran",
  },
  {
    id: "modern",
    name: "Islamic Republic",
    startYear: 1979,
    endYear: undefined,
    description: "The current Islamic Republic of Iran",
  },
];

/**
 * Modern Iran region with current borders
 */
export const IRAN_REGION: Region = {
  id: "region-iran",
  code: "iran",
  name: "Iran",
  localizedNames: {
    en: "Iran",
    fa: "ایران",
    ar: "إيران",
    ku: "Îran",
    az: "İran",
    tr: "İran",
  },
  description: "The Islamic Republic of Iran, located in Western Asia",
  // Border data is loaded from src/data/borders/iran.json via getRegionBorder()

  viewport: {
    center: { lat: 32.4279, lng: 53.6880 },
    zoom: 5,
    minZoom: 4,
    maxZoom: 18,
  },

  area: 1648195, // Square kilometers

  status: "active", // Active and visible to public
  visibility: "public", // Visible to all users

  isDefault: true, // Iran is the default region

  features: {
    canCreateMaps: true,
    canViewPublicMaps: true,
    canUseTemplates: true,
    hasHistoricalData: true,
  },

  defaultMapStyle: "light",
  themeColor: "#00a651", // Green from Iranian flag
  flagEmoji: "🇮🇷",
  thumbnailUrl: "/images/regions/iran-thumbnail.jpg",

  historicalPeriods: IRAN_HISTORICAL_PERIODS,

  childRegions: [
    "region-kurdistan-iran",
    "region-baluchistan-iran",
    "region-azerbaijan-iran",
  ],

  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  order: 1,
  tags: ["middle-east", "persian", "shia", "islamic-republic"],
};

